import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_ROOT } from "../../../utils/api-config";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_ROOT,
    prepareHeaders: (headers) => {
      const token = sessionStorage.getItem("tokenRequest");
      headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["Auth"],
  endpoints: (builder) => ({
    authOauth: builder.mutation({
      query: (payload) => ({
        url: "register_oauth_app/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Auth"],
    }),

    authGetToken: builder.mutation({
      query: (payload) => ({
        url: "token/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Auth"],
    }),

    authValidatePin: builder.mutation({
      query: (payload) => ({
        url: "api/validate_pin/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Auth"],
    }),
  }),
});

export const { useAuthOauthMutation, useAuthGetTokenMutation, useAuthValidatePinMutation } = authApi;
